<script lang="ts">export let label = '';
export let id = '';
export let type = 'text';
export let placeholder = '';
export let required = false;
export let autocomplete = null;
</script>

<div class="w-full">
    <label class="label-text mb-1" for="{id}">{label}</label>
    <input type="{type}" placeholder="{placeholder}" class="input" name="_{id}" id="{id}" {required} {autocomplete}/>
</div>
